import { Link } from 'react-router-dom';

import companyLogoWhite from '../assets/images/logo-white.png';
import youtubeLogo from '../assets/images/icon-youtube.svg';
import FacebookLogo from '../assets/images/icon-facebook.svg';
import instagramLogo from '../assets/images/icon-instagram.svg';

const Footer = () => {
  return (
    <div className='bg-veryDarkBlue'>
      <div className='container flex flex-col-reverse justify-between px-6 py-10 mx-auto space-y-8 md:flex-row md:space-y-0'>
        <div className='flex flex-col-reverse items-center justify-between space-y-12 md:flex-col md:space-y-0 md:items-start'>
          <div className='mx-auto my-6 text-center text-white md:hidden'>
            Copyright © {new Date().getFullYear()}, All Rights Reserved.
          </div>
          <div>
            <img src={companyLogoWhite} className='h-8' alt='' />
          </div>
          <div className='flex justify-center space-x-4'>
            <Link to='https://www.youtube.com/@HOTLINETecnologia/videos' target='_blank' rel='noopener noreferrer'>
              <img src={youtubeLogo} className='h-8' alt='' />
            </Link>
            <Link to='https://www.instagram.com/hotlinetecnologia/' target='_blank' rel='noopener noreferrer'>
              <img src={instagramLogo} className='h-8' alt='' />
            </Link>
            <Link to='https://www.facebook.com/share/1UWgqopA4s/' target='_blank' rel='noopener noreferrer'>
              <img src={FacebookLogo} className='h-8' alt='' />
            </Link>
          </div>
        </div>
        <div className='flex justify-around space-x-32'>
          <div className='flex flex-col space-y-3 text-white'>
            <a href='#features' className='hover:text-brightRed'>
              Benficios
            </a>
            <a href='#auditPro' className='hover:text-brightRed'>
              Como funciona?
            </a>
            <a href='https://hotlinetecnologia.com.br/' className='hover:text-brightRed'>
              Site hotline
            </a>
          </div>
        </div>
        <div className='flex flex-col justify-between'>
          <div className='hidden text-white md:block'>
            Copyright © {new Date().getFullYear()}, All Rights Reserved
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
